import React, { useContext } from 'react';

import { Context } from '@store/store';

import { StyledButton } from './comment-button.styles';
import SourceIcon from '@icons/editor/source-icon';

const SourceButton = ({ isMobile }) => {
  const [, dispatch] = useContext(Context);

  return (
    <StyledButton
      data-ignore-click-outside="sidebar"
      onClick={() => {
        dispatch({ type: 'TOGGLE_EDITOR_SOURCE_MODAL' });
      }}
      title="Использованные источники"
    >
      <SourceIcon width={isMobile ? 20 : 28} height={isMobile ? 20 : 28} />
    </StyledButton>
  );
};

export default SourceButton;